
import axios from 'axios';
import BaseLoader from '@/components/BaseLoader.vue';
import { defineComponent, nextTick, PropType, ref } from 'vue';
import { useForm } from '@/store/form';
import { Work } from '@/types';

export default defineComponent({
  components: {
    BaseLoader,
  },
  props: {
    work: { type: Object as PropType<Work>, required: true },
  },
  setup(props) {
    const firstInput = ref<HTMLInputElement | null>(null);
    const { name, email, phone, valid, validate } = useForm();
    const active = ref(false);
    const submitting = ref(false);
    const submitted = ref(false);

    const postInquiry = async () => {
      try {
        const params = new URLSearchParams();
        params.append('serial', props.work.serial);
        params.append('title', props.work.title);
        params.append('email', email.value);
        params.append('name', name.value);
        params.append('phone', phone.value);
        await axios.post(process.env.VUE_APP_INQUIRE_ENDPOINT, params);
        submitted.value = true;
      } catch (e) {
        submitted.value = false;
        valid.value = 'Something went wrong, please try again later.';
      } finally {
        submitting.value = false;
      }
    };

    const onSubmit = async () => {
      if (!active.value) {
        active.value = true;
        await nextTick();
        if (firstInput.value) {
          firstInput.value.focus();
        }
      } else {
        valid.value = validate();
        if (valid.value === true) {
          submitting.value = true;
          postInquiry();
        }
      }
    };

    return {
      submitting,
      submitted,
      firstInput,
      name,
      email,
      phone,
      active,
      onSubmit,
      valid,
    };
  },
});
